/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![HammerXIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABt0lEQVR4nL2UvS8EQRTAV1ChRFAqFQq9K5BIzvvYYu49XKU4HR0tjUSi1Qm1P0AlCCeiIBJOwv9wlCIhyNzenr1zHzt3eMlkJ7Ozv997MzvjeW7RxizDxphu77cDEXuA9RBZP4H0aYZk4tfgU1PpLmA9sfCwAekLYmqyZbgxphtJslF4pQRI1211yaQZcoYD61k1eETyHuk/+v78QGwBsmzXg1dvshVfQHLhAgeSPICOxBYQzS66CZrYeCBZ/Q/JmqvE+ZyAs0Ty9vz8qYRZhhtCkWQDWfcSiUSHiwRYDuzdVR/OslX6iGQ/lKCvS8iy7PvpvmljeoF0BVlfbSv0UQcbZx6Fc0myUWv+DM8mEFPjDcG14ECST/qp0YrlywLLpa0iHCtUFFyMOy3BbSDpdXG9by3YNiS9C8b02GsFbsPuAbLkQkkIt0/7zqvyt1ReXM/Mc2NenShIQnCQ+cOPGxVZNl0yr1VFUXAPoP2lCZlMphNZ35qBTxc2VG6L1ea+RZIrWyJgySDrhwvcC5b1KATarC00FALLTdlBQ9YFJD2PCw8S011gPY1mW6zqyu6FMaY9Lqvp+ALAveISWMfl5wAAAABJRU5ErkJggg==)
 */
export const HammerXIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15.3 15.3a1 1 0 0 1 1.4 0l2.3 2.29 2.3-2.3a1 1 0 0 1 1.4 1.42L20.42 19l2.3 2.3a1 1 0 1 1-1.42 1.4L19 20.42l-2.3 2.3a1 1 0 0 1-1.4-1.42L17.58 19l-2.3-2.3a1 1 0 0 1 0-1.4ZM1.23 21.13a1 1 0 0 1 0-1.41l7.48-7.48c.2-.2.5-.2.7 0l2.13 2.12c.2.2.2.52 0 .71l-7.48 7.48a1 1 0 0 1-1.41 0l-1.42-1.42ZM18.65 14.4l-.53-.52a3 3 0 0 0-3.86-.32c-.22.16-.54.16-.73-.03L7.76 7.76a2 2 0 0 1 0-2.83l3.53-3.54a2 2 0 0 1 2.83 0l2.72 2.72.66-.66a1 1 0 0 1 1.41 0l1.41 1.42a1 1 0 0 1 0 1.41l-.65.66 2.94 2.94a2 2 0 0 1 0 2.83l-.14.14c-.1.1-.26.15-.4.15a3 3 0 0 0-2.2.88l-.52.52a.5.5 0 0 1-.7 0Z"
        className={colorClass}
      />
    </svg>
  );
};
